module.exports = __webpack_public_path__ + "static/media/flowers_15.14e8d28e.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_15.csv
// module id = 754
// module chunks = 0